import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "fh-blank",
  templateUrl: "blankLayout.template.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet],
})
export class BlankLayoutComponent {
  private titleService = inject(Title);

  constructor() {
    this.titleService.setTitle(window["server_variables"].ApplicationName);
  }
}
